import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import React, { FC } from 'react';
import { Box } from '@idk-web/core-ui';
import { EidProvider } from '@idk-web/api';
import { translateProvider } from '@/utils/translation';
import EidProviderIcon from '@/components/common/visual/EidProviderIcon';

type AuthProvierLabelProps = {
  provider: EidProvider;
};

const EidProviderLabel: FC<AuthProvierLabelProps> = ({ provider }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box alignY="center" spacing={theme.spacing[1]} style={{ width: 'auto' }}>
      {[EidProvider.FTN].includes(provider) && translateProvider(t, provider)}
      <EidProviderIcon withTooltip={false} provider={provider} />
    </Box>
  );
};

export default EidProviderLabel;
